// The AI agent answers "show other images" by listing product gallery image
// URLs as plain text. In the chat bubble those render as raw links, so we
// detect the image URLs, lift them out of the text, and render them as a small
// image gallery instead. Mirrors the Messenger adapter behaviour.

const INLINE_IMAGE_URL_PATTERN = /https?:\/\/[^\s<>"')\]]+\.(?:png|jpe?g|webp|gif)(?:\?[^\s<>"')\]]*)?/gi;
const MAX_INLINE_IMAGES = 30;

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function extractInlineImageUrls(text: string | undefined | null): string[] {
  if (!text) return [];
  const matches = text.match(INLINE_IMAGE_URL_PATTERN) ?? [];
  return Array.from(new Set(matches.map((url) => url.trim()))).slice(0, MAX_INLINE_IMAGES);
}

export function stripInlineImageUrls(text: string, urls: string[]): string {
  let result = text;
  for (const url of urls) {
    const escaped = escapeRegExp(url);
    // Remove a full markdown link/image wrapper "[label](url)" / "![label](url)"...
    result = result.replace(new RegExp(`!?\\[[^\\]]*\\]\\(\\s*${escaped}\\s*\\)`, 'g'), '');
    // ...then any remaining bare occurrence of the url.
    result = result.replace(new RegExp(escaped, 'g'), '');
  }
  // Drop leftover empty markdown links "[label]()" and now-empty bullet lines.
  result = result.replace(/!?\[[^\]]*\]\(\s*\)/g, '');
  const lines = result
    .split('\n')
    .map((line) => (/^\s*[-*•]\s*$/.test(line) ? '' : line.replace(/\s+$/, '')));
  return lines
    .filter((line, idx) => !(line === '' && lines[idx - 1] === ''))
    .join('\n')
    .trim();
}
